<template>
  <el-popover
    placement="bottom-end"
    trigger="click"
    popper-class="common-popper-box"
  >
    <img id="qrcode" class="qrcode-box" />
    <div class="icon-box" slot="reference" @click="createQRCode">
      <icon-svg
        v-if="shareType === 'dataSet'"
        size="34"
        icon-class="ic-erweima"
        title="二维码"
      />
      <el-button
        v-if="shareType === 'scene'"
        size="small"
        class="normal-btn primary-ang-btn gr9"
      >
        查看二维码
      </el-button>
    </div>
  </el-popover>
</template>

<script>
import QRCode from "qrcode";

export default {
  props: {
    shareType: String,
    linkUrl: String,
  },
  mounted() {
    this.createQRCode();
  },
  methods: {
    createQRCode() {
      let linkUrl = this.linkUrl;
      let options = {
        errorCorrectionLevel: "L",
      };
      QRCode.toDataURL(linkUrl, options, (error, url) => {
        if (!error) {
          document.getElementById("qrcode").src = url;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.qrcode-box {
  width: 120px;
  height: 120px;
}

.icon-box {
  cursor: pointer;

  .normal-btn {
    margin-left: 8px;
  }
}
</style>